import { useContext, useState } from "react";
import { Formik, Form } from "formik";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import CompanyInfo from "./components/CompanyInfo";
import validations from "./schemas/validations";
import form from "./schemas/form";
import { updateQuery } from "api/UdasWrapper";
import { toast } from "react-toastify";
import { TenantContext } from "context/AppProvider/TenantContext";
import ConfirmationDialog from "layouts/pages/users/reports/components/Reviews/RemoveUserDialog";

function Settings({ setIsEditing, companyOwner }) {
  const { tenantData, setTenantData } = useContext(TenantContext);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);

  if (!tenantData) return null;

  const initialValues = {
    tenant_id: tenantData.tenant_id || "",
    company_name: tenantData.company_name || "",
    email_address: tenantData.email_address || "",
    business_phone: tenantData.business_phone || "",
    address_line_1: tenantData.address_line_1 || "",
    address_line_2: tenantData.address_line_2 || "",
    country: tenantData.country || "",
    county: tenantData.county || "",
    city: tenantData.city || "",
    state: tenantData.state || "",
    zip: tenantData.zip || "",
    logo_url: tenantData.logo_url || "",
  };

  const handleSubmit = async (values) => {
    const input = {
      tenant_id: values.tenant_id,
      company_name: values.company_name,
      email_address: values.email_address,
      business_phone: values.business_phone,
      address_line_1: values.address_line_1,
      address_line_2: values.address_line_2,
      country: values.country,
      county: values.county,
      city: values.city,
      state: values.state,
      zip: values.zip,
      logo_url: tenantData.logo_url || "",
    };

    const data = JSON.stringify({
      query: `mutation UpdateTenant($input: UpdateTenantInput) {
        updateTenant(input: $input) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: { input },
    });

    try {
      const response = await updateQuery(data);
      const result = response?.updateTenant || response?.data?.updateTenant;
      if (response?.errors || result?.isSuccessful !== true) {
        toast.error(result?.message || "Company Profile Update Failed!");
        return;
      }

      setTenantData((previous) => ({ ...previous, ...input }));
      toast.success("Company Profile Updated successfully!");
      setIsEditing(false);
    } catch (error) {
      console.error(error);
      toast.error("Company Profile Update Failed!");
    }
  };

  return (
    <>
      <Formik initialValues={initialValues} validationSchema={validations} onSubmit={handleSubmit} validateOnBlur>
        {({ values, dirty, isSubmitting, setFieldValue }) => (
          <Form id={form.formId} autoComplete="off">
            <CompanyInfo
              companyOwner={companyOwner}
              formData={{ values, setFieldValue, hasEditCompanyInfoAccess: true, isOwner: true }}
            />
            <SoftBox display="flex" justifyContent="flex-end" gap={1.5} mt={3}>
              <SoftButton
                type="button"
                variant="outlined"
                color="primary"
                onClick={() => dirty ? setOpenCancelDialog(true) : setIsEditing(false)}
              >
                Cancel
              </SoftButton>
              <SoftButton type="submit" variant="contained" color="primary" disabled={!dirty || isSubmitting}>
                {isSubmitting ? "Saving..." : "Save changes"}
              </SoftButton>
            </SoftBox>
          </Form>
        )}
      </Formik>
      <ConfirmationDialog
        open={openCancelDialog}
        onClose={() => setOpenCancelDialog(false)}
        onAccept={() => { setOpenCancelDialog(false); setIsEditing(false); }}
        acceptButtonText="Discard changes"
        dialogTitle="Discard changes?"
        dialogContent="Your company changes have not been saved."
        acceptButtonColor="info"
        notArray
      />
    </>
  );
}

export default Settings;
